module.exports = __webpack_public_path__ + "static/img/guide_icon_slider.31d2c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide_icon_slider.png
// module id = cWDd
// module chunks = 1